import '#src/instrument.ts'

import '@seen/ui/src/styles.css'

import { addReactError } from '@datadog/browser-rum-react'
import { mountVercelToolbar } from '@vercel/toolbar/vite'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Root } from '#src/Root.tsx'

// Vercel injects the Toolbar into Preview deployments. In Production, team
// members opt in from the Preview toolbar menu or the browser extension so
// Orbit does not prompt every visitor to sign in to Vercel.
if (__APP_ENV__ === 'development') {
  mountVercelToolbar()
}

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container, {
  onUncaughtError: (error, info) => {
    if (error instanceof Error) {
      addReactError(error, info)
    }
  },
  onCaughtError: (error, info) => {
    if (error instanceof Error) {
      addReactError(error, info)
    }
  },
  onRecoverableError: (error, info) => {
    if (error instanceof Error) {
      addReactError(error, info)
    }
  },
})
root.render(
  <StrictMode>
    <Root />
  </StrictMode>
)
